import {RSAA} from "redux-api-middleware";
import {fetchGameInfoAction} from "../Core/myResultsActions";
import {setLastUpdatedAction, setLastUpdatedNoNewAction, setLastUpdatedUpdatingAction} from "./lastUpdatedReducer";

export const GAMES_UPDATE = 'GAMES_UPDATE';

export const updateAction = () => (dispatch, getState) => {
    const state = getState();
    dispatch(setLastUpdatedUpdatingAction());
    dispatch({
        [RSAA]: {
            endpoint: `/api/v1/updatesSince/${state.lastUpdated.id}`,
            method: 'GET',
            credentials: 'same-origin',
            types: [
                'REQUEST',
                {
                    type: 'SUCCESS',
                    payload: (action, state, res) => (
                        res.json().then(
                            json => {
                                if (!json.data) {
                                    dispatch(setLastUpdatedNoNewAction());
                                    return;
                                }
                                dispatch(setLastUpdatedAction(json.data));
                                let games = json.relationships.games;
                                if (games && games.length) {
                                    dispatch(updateGamesAction(games));
                                    if (games.filter(game => game.id == state.games.current.id).length) {
                                        dispatch(fetchGameInfoAction(state.games.current))
                                    }
                                }
                            }
                        ))
                },
                'FAILURE'
            ]

        }
    });
};

export const updateGamesAction = (games) => ({
    type: GAMES_UPDATE,
    payload: {
        games
    }
});
